export const CAMERA_LIGHT_DISTANCE = -5
export const CAMERA_MIN_DISTANCE_DEFAULT = 1
export const CAMERA_MAX_DISTANCE_DEFAULT = 7
export const CAMERA_MIN_POLAR_DEFAULT: number = Math.PI / 8
export const CAMERA_MAX_POLAR_DEFAULT: number = Math.PI / 2.1
export const CAMERA_MIN_AZIMUTH_DEFAULT = Infinity
export const CAMERA_MAX_AZIMUTH_DEFAULT = Infinity
export const CAMERA_PAN_LIMIT_RATIO = 0.35
export const FIXED_VIEW_TRANSITION_TIME_MS = 500
